var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94501 12.8375C9.75747 13.0251 9.50312 13.1304 9.2379 13.1304H7.86951C7.31722 13.1304 6.86951 12.6827 6.86951 12.1304V10.762C6.86951 10.4968 6.97486 10.2425 7.1624 10.0549L14.5102 2.70711C14.9008 2.31658 15.5339 2.31658 15.9244 2.70711L17.2928 4.0755C17.6834 4.46603 17.6834 5.09919 17.2928 5.48972L9.94501 12.8375Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1305 4.08691L15.9131 6.86952",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3043 9.65232V17.3045C17.3043 17.489 17.2311 17.6659 17.1006 17.7964C16.9701 17.9269 16.7932 18.0001 16.6087 18.0001H2.69565C2.51115 18.0001 2.33421 17.9269 2.20375 17.7964C2.07329 17.6659 2 17.489 2 17.3045V3.39145C2 3.20695 2.07329 3.03001 2.20375 2.89955C2.33421 2.76909 2.51115 2.6958 2.69565 2.6958H10.3478",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fa88a5365f330e4f71b0163470233fa1.svg";
export { ForwardRef as ReactComponent };